import React, { useCallback, useState } from 'react';

import { Button } from 'components/bootstrap';
import type { BsSize } from 'components/bootstrap/types';
import type { StyleProps } from 'components/bootstrap/Button';
import type { EntityShare } from 'actions/permissions/EntityShareActions';
import CollectionModal from 'collections/components/CollectionModal';
import type { Collection } from 'collections/types';
import useCollectionMutation from 'collections/hooks/useCollectionMutation';
import { CurrentUserStore } from 'stores/users/CurrentUserStore';

type Props = {
  bsSize?: BsSize;
  bsStyle?: StyleProps;
  buttonText?: string;
};

const CreateCollectionButton = ({ bsSize = 'md', bsStyle = 'default', buttonText = 'Create collection' }: Props) => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const toggleCreateModal = useCallback(() => setShowCreateModal((cur) => !cur), []);

  const { createCollection } = useCollectionMutation();

  const onCreate = (values: Partial<Collection> & EntityShare) =>
    createCollection({
      share_request: values.share_request,
      entities: [],
      title: values.title,
      description: values.description,
      id: values.id,
    }).then(() => CurrentUserStore.reload());

  return (
    <>
      <Button bsSize={bsSize} bsStyle={bsStyle} onClick={toggleCreateModal}>
        {buttonText}
      </Button>
      {showCreateModal && (
        <CollectionModal
          title="Create collection"
          submitButtonText="Create collection"
          submitLoadingText="Creating collection..."
          onSubmit={onCreate}
          onClose={toggleCreateModal}
          create
        />
      )}
    </>
  );
};

export default CreateCollectionButton;
